/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_LeadInputs */

const en_us2_workout_quick_lead = /** @type {(inputs: Workout_Quick_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your plan is already filled in. Change only what was different.`)
};

const pt_br2_workout_quick_lead = /** @type {(inputs: Workout_Quick_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O plano já está preenchido. Ajuste só o que foi diferente.`)
};

const es_419_workout_quick_lead = /** @type {(inputs: Workout_Quick_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu plan ya está completo. Cambia solo lo que fue diferente.`)
};

const pt_pt2_workout_quick_lead = /** @type {(inputs: Workout_Quick_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O plano já está preenchido. Ajusta só o que foi diferente.`)
};

const fr_fr2_workout_quick_lead = /** @type {(inputs: Workout_Quick_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton programme est déjà rempli. Change seulement ce qui a été différent.`)
};

const de_de2_workout_quick_lead = /** @type {(inputs: Workout_Quick_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Plan ist schon eingetragen. Ändere nur, was anders war.`)
};

const it_it2_workout_quick_lead = /** @type {(inputs: Workout_Quick_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La scheda è già compilata. Cambia solo quello che è stato diverso.`)
};

/**
* | output |
* | --- |
* | "Your plan is already filled in. Change only what was different." |
*
* @param {Workout_Quick_LeadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_lead = /** @type {((inputs?: Workout_Quick_LeadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_LeadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_lead(inputs)
	if (locale === "es-419") return es_419_workout_quick_lead(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_lead(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_lead(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_lead(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_lead(inputs)
	return en_us2_workout_quick_lead(inputs)
});
export { workout_quick_lead as "workout-quick.lead" }